import axios from 'axios';

import cfac22 from '../cfac22';

export default function deleteUser(_uid) {
  return new Promise((resolve, reject) => {
    Promise.resolve().
    then(() => {
      axios.
      delete(cfac22('API_HOST_V2') + '/users', {
        headers: { 'Full-Url': window.location.href }, withCredentials: true
      }).
      then((result) => {
        // console.log("RESULTADO API GETPOWERBI ===>: ", result);
        resolve(result.data);
      }).
      catch((error) => {
        //console.log("ERRO API POWERBI ===>: ", error);
        return reject(error.response.data);
      });
    }).
    catch((error) => {
      //console.log("ERROR_TOKEN:", error);
      reject(error);
    });
  });
}
